// Stable per-row identifiers for editable form lists. Using these as React keys
// (instead of the array index) prevents controlled-input state from shifting to
// the wrong row when a row is added, removed or reordered mid-edit.
let _counter = 0;

export function uid() {
  _counter += 1;
  return `r${Date.now().toString(36)}${_counter.toString(36)}`;
}

// Ensure every row in an array has a stable _uid (assigns one only where missing).
export function withUids(arr) {
  return (arr || []).map((x) => (x && x._uid ? x : { ...x, _uid: uid() }));
}
